"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PushType = exports.NotificationsEndpoints = void 0;
var NotificationsEndpoints;
(function (NotificationsEndpoints) {
    NotificationsEndpoints["TogglePushNotifications"] = "/notifications/toggle-push-notifications";
})(NotificationsEndpoints || (exports.NotificationsEndpoints = NotificationsEndpoints = {}));
/**
 * The push notification type used.
 * Must specify either APN (iOS) or FCM (Android).
 */
var PushType;
(function (PushType) {
    PushType["Unspecified"] = "PUSH_TYPE_UNSPECIFIED";
    /** Apple Push Notification (iOS) */
    PushType["APN"] = "APN";
    /** Firebase Cloud Messaging (Android) */
    PushType["FCM"] = "FCM";
})(PushType || (exports.PushType = PushType = {}));
